<template>
  <div id="project-one-summary-view">
    <h2>ProjectOneSummaryView.vue</h2>
  </div>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
#project-one-summary-view {
  background-color: darkorange;
  color: white;
  height: 100%;
}
</style>
